import React from 'react';

export function mergeProps(...propList): any {
  return propList.reduce((props, next) => {
    const { style, className, ...rest } = next

    props = {
      ...props,
      ...rest,
      style: {
        ...(props.style || {}),
        ...(style || {}),
      },
      className: [props.className, className].filter(Boolean).join(' '),
    }

    if (props.className === '') {
      delete props.className
    }

    return props
  }, {})
}
